module.exports = __webpack_public_path__ + "img/javascript.1ee2f562.png";